import ComunicadosList from './ComunicadosList';
import NoticeIcon from '@material-ui/icons/Public';

const ComunicadosModule = {
    list: ComunicadosList,
    icon: NoticeIcon
}

export default ComunicadosModule;